// extracted by mini-css-extract-plugin
export var dropdownButton = "_2u-0";
export var fullWidthDropdownButton = "_2u-1";
export var icon = "_2u-3";
export var iconPlaceholder = "_2u-2";
export var shortcutContainer = "_2u-4";